//var speechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition || false;

//var recognition = new speechRecognition()




//var content = ''

//recognition.continuous = true

//// recognition is started

//recognition.onstart = function () {

//    $("#instructions").text("Voice Recognition is On")

//}

//recognition.onspeechend = function () {

//    $("#instructions").text("No Activity")

//}

//recognition.onerror = function (error) {

//    console.log(error);
//    $("#instructions").text("Try Again:")

//}

//recognition.onresult = function (event) {

//    var resultText = "";

//    try {
//        var current = event.resultIndex;
//        var transcript = event.results[current][0].transcript;
//        resultText = transcript;
        
//    }
//    catch (e) {

//    }

//    guardSpeechDone(resultText);
//}



//var lastFocusedElementGuardScreenGridCell = null;
//$(function () {
//    $(this).click(function () {
//        //document.activeElement;
//        //console.log(lastFocusedElementGuardScreen.tagName, lastFocusedElementGuardScreen.type || 'N/A');
//        lastFocusedElementGuardScreenGridCell = $('.highlight-selected');
//    });
//});

//function triggerMouseEvent(node, eventType) {
//    var clickEvent = document.createEvent('MouseEvents');
//    clickEvent.initEvent(eventType, true, true);
//    node.dispatchEvent(clickEvent);
//}


//function setupSpeechControls(arg) {

    
//    var simulateVoice = true;
//    var simulatedText = '5 Oliver Drive';

//    $(function () {

//        $("#guardStartSpeakButton").click(function (event) {

//            event.preventDefault(); //If we click Speak button, we dont want to loose focus on target input
//            event.stopPropagation();

//            console.log(guardScreenCheckinSpreadsheetReceiverUnitColumnIndex);

 
//            if (!simulateVoice) {
//                console.log("start voice");
//                recognition.start();
//            } else {
//                console.log("simulating voice");
//                guardSpeechDone(simulatedText);
//            }


            

//        })
//    });

//    return 1;

//}

//function guardSpeechDone(text) {
//    console.log("voice from guard: " + text);


   


//    if (lastFocusedElementGuardScreenGridCell != null) {

//        var el = $(lastFocusedElementGuardScreenGridCell)[0];

//        if (el != null) {

//            setTimeout(function () {

//                triggerMouseEvent(el, "mousedown");
//                triggerMouseEvent(el, "mouseup");

//                console.log("receiversCache");
//                console.log(receiversCache);

//                console.log("click");
//                console.log($(el))

//                //$(el).html(text);
//                //$(el).val(text);
//                //$(el).change();

               
//                //alert("similarity: " + similarity);

//                // similarity = stringSimilarity.compareTwoStrings("100 Olive Drive", "100 Orange Drive");
//                //alert("similarity: " + similarity);


//                var gridIndex = -1;

//                try {
                    
//                    var gridElementId = ($($(el).parent().parent().parent().parent().parent()).attr('id'));
//                    var gridIndex = parseInt(gridElementId.replace('guardScreenSpreadsheet', ''));

//                    console.log("gridIndex: " + gridIndex);

//                } catch { }

//                if (gridIndex >= 0) {
//                    var columnX = $(el).attr("data-x");
//                    var columnY = $(el).attr("data-y");

//                    if (columnY != 0) {
//                        DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnShowGuardScreenSnackbar', "Please mark top row to use voice input", 'normal');
//                        return;
//                    }

//                    DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnShowGuardScreenSnackbar', 'Text heard: ' + text, 'normal');

//                    // console.log("dataX: " + dataX);

//                    var columnValue = text;

//                    //Find the column in what grid that was selected before starting voice

//                    var property = "receiverUnit";

//                    var lookedUpValueToSet = null;

//                    var specialColumnToSet = false;

//                    //ReceiverUnit
//                    if (guardScreenCheckinSpreadsheetReceiverUnitColumnIndex[gridIndex] == columnX ||
//                        guardScreenCheckinSpreadsheetReceiverNameColumnIndex[gridIndex] == columnX) {

//                        specialColumnToSet = true;

//                        property = guardScreenCheckinSpreadsheetReceiverUnitColumnIndex[gridIndex] == columnX ? "receiverUnit" : "receiverName";
//                        var receiversCount = receiversCache.length;

//                        var mostSimilarReceiver = null;
//                        var mostSimilarReceiverScore = 0;

//                        for (var i = 0; i < receiversCount; i++) {

//                            var similarity = 0;
//                            try {
//                                similarity = stringSimilarity.compareTwoStrings(receiversCache[i][property].toLowerCase(), text.toLowerCase());
//                            }
//                            catch (e) {
//                                similarity = 0;
//                            }

//                            if (similarity > mostSimilarReceiverScore) {
//                                mostSimilarReceiver = receiversCache[i];
//                                mostSimilarReceiverScore = similarity;

//                            }


//                        }

//                        lookedUpValueToSet = mostSimilarReceiver[property];


//                    }
//                    else if (guardScreenCheckinSpreadsheetAutoAdmitNameColumnIndex[gridIndex] == columnX) {

//                        specialColumnToSet = true;

//                        text = "harry";
//                        var mostSimilarAutoAdmitName = null;
//                        var mostSimilarAutoAdmitNameScore = 0;

//                        var receiverUnitColumnIndex = guardScreenCheckinSpreadsheetReceiverUnitColumnIndex[gridIndex];
//                        var unit = guardScreenCheckinSpreadsheet[gridIndex].getRowData(0)[receiverUnitColumnIndex];
//                        console.log("read unit: " + unit);

//                        if (receiversCache != null) {
//                            var receiversCacheLength = receiversCache.length;
//                            for (var rx = 0; rx < receiversCacheLength; rx++) {
//                                if (receiversCache[rx].receiverUnit == unit) {

//                                    try {
//                                        var tempAutoAdmitObject = JSON.parse(receiversCache[rx].receiverAllowList); // should check for null, try catch instead

//                                        console.log("auto admit list found");
//                                        console.log(tempAutoAdmitObject);

                                       

//                                        for (var rxa = 0; rxa < tempAutoAdmitObject.length; rxa++) {
//                                            var aValue = tempAutoAdmitObject[rxa]["AutoAdmitName"];
//                                            if (aValue != null && aValue != "") {

//                                                var isVendor = false;
//                                                try {
//                                                    isVendor = tempAutoAdmitObject[rxa]["AutoAdmitIsVendor"];
//                                                }
//                                                catch { }

//                                                var isAutoAdmitPerson = false;
//                                                try {
//                                                    isAutoAdmitPerson = tempAutoAdmitObject[rxa]["AutoAdmitType"] == 0;
//                                                }
//                                                catch { }

//                                                //Add to auto admit dropdown, do not include vehicles and property access entries
//                                                if (isAutoAdmitPerson) {
//                                                    //if (gridIndex == 0 && !isVendor) {
//                                                    //    autoAdmitsForReceiver.push(aValue);
//                                                    //}
//                                                    //else if (gridIndex == 1 && isVendor) {
//                                                    //    autoAdmitsForReceiver.push(aValue);
//                                                    //}


//                                                    var similarity = 0;
//                                                    try {
//                                                        console.log("comparing " + aValue.toLowerCase() + " and " + text.toLowerCase());
//                                                        similarity = stringSimilarity.compareTwoStrings(aValue.toLowerCase(), text.toLowerCase());
//                                                    }
//                                                    catch (e) {
//                                                        similarity = 0;
//                                                    }

//                                                    if (similarity > 0.5 && similarity > mostSimilarAutoAdmitNameScore) {
//                                                        mostSimilarAutoAdmitName = aValue;
//                                                        mostSimilarAutoAdmitNameScore = similarity;
//                                                        lastLookedUpAutoAdmitList = tempAutoAdmitObject;

//                                                    }
//                                                }



//                                                //var dropdownObject = { 'id': aValue, 'name': aValue, 'something': 'hello'};

//                                            }
//                                        }

//                                        lookedUpValueToSet = mostSimilarAutoAdmitName;
//                                    } catch (e) {
//                                        //console.log(e);
//                                    }


//                                    break;
//                                }
//                            }
//                        }

//                    }

//                    console.log("mostSimilarAutoAdmitNameScore: " + mostSimilarAutoAdmitNameScore);

//                    console.log("lookedUpValueToSet: " + lookedUpValueToSet );

//                    if (specialColumnToSet) {

//                        if (lookedUpValueToSet == null) {
//                            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnShowGuardScreenSnackbar', "Not found!", 'error');
//                        }
//                        else {
//                            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnShowGuardScreenSnackbar', "Text found: " + lookedUpValueToSet, 'info');

//                            guardScreenCheckinSpreadsheet[gridIndex].setValueFromCoords(columnX, 0, lookedUpValueToSet, true);
//                            guardScreenCheckinSpreadsheet[gridIndex].dispatch('onchange', el, lookedUpValueToSet);
//                        }

//                    }
//                    else {
//                        guardScreenCheckinSpreadsheet[gridIndex].setValueFromCoords(columnX, 0, text, true);
//                        guardScreenCheckinSpreadsheet[gridIndex].dispatch('onchange', el, text);
//                    }
                 

                    
                        

//                    //guardScreenCheckinSpreadsheet[gridIndex].setValueFromCoords(columnX, 0, lookedUpValueToSet, false);
//                }


             

//              //  el.innerHTML = text;


//            }, 1000);

//        }

//    }
//}


